import Image from 'next/image';
import { BenefitItemT } from './helpers';

type BenefitItemProps = {
  item: BenefitItemT;
};

export default function BenefitItem({ item }: BenefitItemProps) {
  const Icon = item.icon;

  return (
    <div className="flex items-center gap-2 text-xs leading-tight">
      <Icon className="hidden h-3.5 w-3.5 shrink-0 lg:block" />
      <div className="flex h-6 w-6 items-center justify-center rounded bg-[#D6FFE2] text-[#128452] lg:hidden">
        <Icon className="h-3.5 w-3.5 shrink-0" />
      </div>
      {item.label}
      {item.flag && (
        <Image
          alt=""
          src={item.flag}
          height={12}
          width={18}
          className="h-4 w-auto shrink-0"
        />
      )}
    </div>
  );
}
